// src/components/billing/ContractHeaderActions.tsx
import { ActionIcon, Button, Group, Menu } from "@mantine/core";
import { IconCopy, IconDotsVertical, IconDownload, IconFilePlus, IconTrash } from "@tabler/icons-react";

interface Props {
  onTerminate: () => void;
  onClone: () => void;
  onExportPdf: () => void;
  onNewContract: () => void;
  canTerminate?: boolean;
  canCreate?: boolean;
}

export function ContractHeaderActions({
  onTerminate,
  onClone,
  onExportPdf,
  onNewContract,
  canTerminate = true,
  canCreate = true,
}: Props) {
  return (
    <Group gap="xs">
      {canTerminate && (
        <Button color="red" variant="light" size="xs" leftSection={<IconTrash size={14} />} onClick={onTerminate}>
          Цуцлах
        </Button>
      )}
      <Menu position="bottom-end" withinPortal>
        <Menu.Target>
          <ActionIcon variant="subtle" aria-label="Илүү үйлдлүүд">
            <IconDotsVertical size={18} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<IconCopy size={14} />} onClick={onClone}>Хувилах</Menu.Item>
          <Menu.Item leftSection={<IconDownload size={14} />} onClick={onExportPdf}>PDF татах</Menu.Item>
          {canCreate && (
            <Menu.Item leftSection={<IconFilePlus size={14} />} onClick={onNewContract}>
              Шинэ гэрээ
            </Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
}
